module.exports = __webpack_public_path__ + "img/banner_1.85353c9c.jpg";